import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  FormGroup,
  CircularProgress,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import React, { useCallback, useContext, useState, useRef } from "react";
import { useEffect } from "react";
import { AdminCheckContext } from "../MockTest";
import Typo from "typo-js";
import swal from "sweetalert";
// import { grammar_check } from "../../Writing/WriteEssay/GrammarCheck";
import { updateUserData } from "../StoreDataFunctions";
import { requestAudio } from "../../../../../customHooks/Permissions/RequestPermission";
import { MtErrorFallbackFunction } from "../../../../../components/ErrorFallbackFunction";
import ErrrorBoundaryClass from "../../../../../components/ErrrorBoundaryClass";
import { useTheme } from "@emotion/react";
import { CircularProgressbar } from "react-circular-progressbar";
import CalculateScore from "../../CalculationForWritingSections.js/CalculateScore";
import { saveTempMt } from "../../../../../Utils/SaveTempMt";
import { useParams } from "react-router-dom";
import { max } from "lodash";
import { safeJsonParse } from "../SaveDataFunction";

function ReusableTest(props) {
  const {
    mockType,
    answer,
    timerCounterDuration,
    pteType,
    setDetailAnswer,
    setDetailDuration,
    testPost,
    category,
    setCategoryState,
    setCurrentPage,
    pause,
    setPause,
    mockId,
    setWritingState,
    setListeningState,
    setCurrentCategory,
    passSaveDataState,
    setPassSaveDataState,
    currentIndex,
    setCurrentIndex,
    setCurrentQuestionStart,
    error,
    setError,
    setSave,
    checkAnswerState,
  } = props;
  // console.log(testPost,"Test >>>")

  const data = useParams();
  const theme = useTheme();
  const checkByAdmin = useContext(AdminCheckContext);
  const isEssay = category === "we";
  const isEmail = category === "wemail";
  const isWriting = category === "swt" || isEssay || isEmail;
  const isCore = pteType === "core";
  const [timerCounterCount, setTimerCounterCount] =
    useState(timerCounterDuration);
  const [counter, setCounter] = useState(false);

  const [index, setIndex] = useState(0);
  const rawTestPost = testPost?.[index];
  const currentTestPost =
    rawTestPost?.post ?? rawTestPost?.post_data?.[0] ?? rawTestPost;
  const [storeData, setStoreData] = useState();

  //check answer const
  const [spelling, setSpelling] = useState(0);
  const [wordForm, setWordForm] = useState(0);
  const [dsc, setDsc] = useState(0);
  const [linguistic, setLinguistic] = useState(0);
  const [vocabulary, setVocabulary] = useState(0);
  const [contentAns, setContentAns] = useState(0);
  const [overallPoint, setOverallPoint] = useState(0);
  const [grammarMark, setGrammarMark] = useState(0);
  const [dbSaveLoading, setDbSaveLoading] = useState(false);
  const [calculationLoading, setCalculationLoading] = useState(false);
  const [errorCount, setErrorCount] = useState(0);
  const [pageCleanUp, setPageCleanUp] = useState(true);
  //for audio
  const [audio, setAudio] = useState("");
  const [beginningStatus, setBeginningStatus] = useState(true);
  // let [contentArr, setContentArr] = useState();
  //for wfd
  const [next, setNext] = useState(false);
  let frontendURL = process.env.REACT_APP_FRONTEND_URL;
  let [char, setChar] = useState();
  let [wordCount, setWordCount] = useState(0);
  const [text, setText] = useState("");
  const [contentMaxScore, setContentMaxScore] = useState(0); // Default max score for SWT and SST
  //spelling check
  const [dictionary, setDictionary] = useState(null);

  // Always keep a ref to the latest save_score so effects can call it
  // without having save_score in their deps (which causes unstable loops)
  const save_score_ref = useRef(null);

  //for audio permission
  //checkPermission
  useEffect(() => {
    requestAudio().catch(() => alert("No support Audio Permission"));
  }, []);

  //set audio
  useEffect(() => {
    if (!currentTestPost) {
      return;
    }
    if (category === "sst" || category === "wfd") {
      if (currentTestPost.media_type === "1") {
        setAudio(currentTestPost.media);
      } else {
        setAudio(
          `${process.env.REACT_APP_BACKEND_URL}storage/${category}/${currentTestPost.media}`,
        );
      }
    }
  }, [index, props, audio, category, currentTestPost, props.currentPage]);

  //audio end handler
  const audioEndHandler = () => {
    setCounter(true);
    setBeginningStatus(false);
  };

  const onLoadedMetaData = () => {
    const audio = document.querySelector("#audio");
    audio.play();
  };

  //get set data from local storage and set current state
  useEffect(() => {
    if (!checkAnswerState && !passSaveDataState) {
      const userId = localStorage.getItem("userId");
      const perMockKey = userId + "saveMt" + mockId + category;
      const raw =
        localStorage.getItem(perMockKey) ?? localStorage.getItem(category);
      let getStoreData = safeJsonParse(raw);
      if (!getStoreData || typeof getStoreData !== "object") {
        if (Array.isArray(testPost)) {
          getStoreData = {
            post: testPost.map((p) => p.id).toString(),
            score: Array(testPost.length).fill(0),
            answer: Array(testPost.length).fill([""]),
            question_number: testPost.length,
            points: Array(testPost.length).fill(""),
          };
        }
      }
      if (getStoreData && typeof getStoreData === "object") {
        getStoreData.score =
          typeof getStoreData.score === "string"
            ? getStoreData.score.split(",")
            : Array.isArray(getStoreData.score)
              ? getStoreData.score
              : [];
        getStoreData.answer =
          typeof getStoreData.answer === "string"
            ? (safeJsonParse(getStoreData.answer) ?? [])
            : (getStoreData.answer ?? []);
        getStoreData.points =
          typeof getStoreData.points === "string"
            ? (safeJsonParse(getStoreData.points) ?? [])
            : (getStoreData.points ?? []);

        setStoreData(getStoreData);
      }
      setCurrentCategory(category);
      if (category === "sst" || category === "wfd") {
        setCurrentQuestionStart(true);
      }
    }
  }, [
    category,
    setCurrentCategory,
    passSaveDataState,
    checkAnswerState,
    setCurrentQuestionStart,
    mockId,
    testPost,
  ]);

  //SET TO store index if save data exist
  //tracking index
  //tracking answer and time in case of no internet

  useEffect(() => {
    if (passSaveDataState) {
      let saveCategory = localStorage.getItem("saveCategory");
      let saveIndex = localStorage.getItem("saveIndex");
      if (category === "sst" || category === "wfd") {
        setCurrentQuestionStart(true);
      }

      if (saveCategory == category) {
        // console.log(saveIndex,"Test >>>")
        setIndex(parseInt(saveIndex));
        setCurrentIndex(saveIndex);
        setPassSaveDataState(false);
        if (category === "swt" || category === "we" || category === "wemail") {
          setTimerCounterCount(localStorage.getItem("detailDuration"));
          let textBox = document.getElementById("textBox");
          setText(localStorage.getItem("detailAnswer"));
          let char = localStorage.getItem("detailAnswer");
          const char_arr = char ? char.split(" ") : [];

          setChar(char);
          setWordCount(char_arr.length);
        }

        setTimeout(() => {
          localStorage.removeItem("saveCategory");
          localStorage.removeItem("saveIndex");
          localStorage.removeItem("detailDuration");
          localStorage.removeItem("detailAnswer");
        }, 2500);
      } else {
        setCategoryState(false);
      }
    }
    setCurrentIndex(index);
  }, [
    index,
    setCurrentIndex,
    setCurrentQuestionStart,
    currentIndex,
    setPassSaveDataState,
    passSaveDataState,
    category,
    setCategoryState,
  ]);

  //save answer every second
  useEffect(() => {
    if (
      !passSaveDataState &&
      !checkAnswerState &&
      (category === "we" || category === "swt" || category === "wemail")
    ) {
      let textBox = document.getElementById("textBox");
      setDetailAnswer(textBox.value);
      setDetailDuration(timerCounterCount);
    }
  }, [
    timerCounterCount,
    checkAnswerState,
    category,
    setDetailAnswer,
    setDetailDuration,
    passSaveDataState,
  ]);

  useEffect(() => {
    const loadDictionary = async () => {
      const affData = await fetch(
        `${process.env.REACT_APP_FRONTEND_URL}/en_US.aff`,
      ).then((res) => res.text());
      const wordsData = await fetch(
        `${process.env.REACT_APP_FRONTEND_URL}/en_US.dic`,
      ).then((res) => res.text());
      const dictionary = new Typo("en_US", affData, wordsData);
      setDictionary(dictionary);
    };
    loadDictionary();
  }, []);

  //reset answer
  const reset = useCallback(() => {
    let textBox = document.getElementById("textBox");
    // textBox.value = "";
    textBox.focus();
    setWordCount(0);
    setGrammarMark(0);
    setPageCleanUp(true);
    setContentAns(0);
    setWordForm(0);
    setVocabulary(0);
    setSpelling(0);
    setChar("");
    setText("");
    setGrammarMark(0);
    setContentAns(0);
    setWordForm(0);
    setDsc(0);
    setLinguistic(0);
    setVocabulary(0);
    setSpelling(0);

    setTimerCounterCount(timerCounterDuration);
    setNext(false);
    setBeginningStatus(true);
  }, [timerCounterDuration]);

  const checkWord = (event) => {
    let char = event.target.value;
    setText(event.target.value);
    const char_arr = char
      .trim()
      .replace(/\(([^)]*)\)/g, "$1") // Remove only the parentheses while retaining the text inside
      .replace(/[.,?'()]/g, " ") // Remove punctuation characters and any remaining parentheses
      // .replace(/[.,?']/g, "")
      .split(/\s+/)
      .filter((word) => word !== "");

    setChar(char);
    setWordCount(char_arr.length);
  };

  useEffect(() => {
    let beginInterval = (pause) => {
      if (timerCounterCount !== 0 && !pause && !checkAnswerState) {
        if (category === "sst") {
          if (counter) {
            const interval = setInterval(() => {
              setTimerCounterCount((prev) => prev - 1);
            }, 1000);
            return interval;
          }
        } else {
          const interval = setInterval(() => {
            setTimerCounterCount((prev) => prev - 1);
          }, 1000);
          return interval;
        }
      }
    };
    let interval = beginInterval(pause);
    return () => clearInterval(interval);
  }, [timerCounterCount, pause, category, counter, checkAnswerState]);

  useEffect(() => {
    if (timerCounterCount === 120) {
      let audio = new Audio(frontendURL + "/beep.mp3");
      audio.play();
    }
  });
  const clickHandler = () => {
    setTimerCounterCount(0);
    setNext(true);
    if (checkAnswerState) {
      pageCondition();
    }
  };

  //page Condition
  const pageCondition = useCallback(async () => {
    if (pageCleanUp) {
      setPageCleanUp(false);
      setPause(true);
      setDbSaveLoading(true);
      setCalculationLoading(false);
      let updateDbSave = async () => {
        if (!checkAnswerState) {
          await saveTempMt(data.id, data.mt_type_id);
        }
      };

      await updateDbSave();
      if (!checkAnswerState) {
        let section;
        if (category === "we" || category === "swt" || category === "wemail") {
          section = "Writing";
        } else {
          section = "Listening";
        }
        updateUserData(section, category, storeData, mockId);

        if (category === "sst" || category === "wfd") {
          setCurrentQuestionStart(true);
        }
      }

      //page change
      if (index === props.testPost.length - 1) {
        if (category === "wemail") {
          // End only the email category; continue to SWT in Core
          setCategoryState(false);
          setCurrentPage((prev) => prev + 1);
        } else if (category === "swt") {
          setCategoryState(false);
          if (isCore) {
            setWritingState(false);
            if (mockType !== 6) {
              props.setSectionA(false);
              props.setCounterState(true);
              props.setCurrentPage(1);
              setCurrentCategory("rsmc");
            }
          } else {
            // Academic continues to Essay after SWT
            setCurrentPage((prev) => prev + 1);
          }
        } else if (category === "we") {
          setCategoryState(false);
          setWritingState(false);
          if (mockType !== 6) {
            props.setSectionA(false);
            props.setCounterState(true);
            props.setCurrentPage(1);
            setCurrentCategory("rsmc");
          }
        } else {
          setCategoryState(false);
          setCurrentPage((prev) => prev + 1);
        }
      } else {
        setCurrentPage((prev) => prev + 1);
        setIndex((prev) => prev + 1);
        reset();
      }
      setDbSaveLoading(false);
      setCalculationLoading(false);
      setPause(false);
      setSave(true);
    }
  }, [
    category,
    pageCleanUp,
    setSave,
    checkAnswerState,
    index,
    mockType,
    setPause,
    props,
    data,
    reset,
    setCategoryState,
    setListeningState,
    setWritingState,
    setCurrentQuestionStart,
    setCurrentPage,
    storeData,
  ]);

  const save_score = useCallback(
    async (charOverride) => {
      const effectiveChar = charOverride !== undefined ? charOverride : char;
      // console.log("[save_score] called", { charOverride, char_state: char, effectiveChar, index, category });
      if (!currentTestPost) {
        setCalculationLoading(false);
        return;
      }
      let content_arr;
      setPause(true);
      setCalculationLoading(true);
      if (category === "we" || category === "swt" || category === "wemail") {
        if (!currentTestPost.transcript) {
          setCalculationLoading(false);
          return;
        }
        content_arr = currentTestPost.transcript
          .split(/[\(\),\s]+/)
          .filter(Boolean)
          .map((transcript) => transcript.replace(/\./g, "").trim());
      } else {
        if (!currentTestPost.content) {
          setCalculationLoading(false);
          return;
        }
        content_arr = currentTestPost.content.split(/[ .,]+/);
      }
      let keyword_length = currentTestPost.keyword_length;
      // let content_kw_length =
      //   keyword_length > 0 ? keyword_length : content_arr.length;

      if (effectiveChar !== "" && effectiveChar !== undefined) {
        let score;
        let points;
        if (category !== "wfd") {
          let result = await CalculateScore(
            category === "sst"
              ? currentTestPost.content
              : currentTestPost.transcript,
            effectiveChar,
            keyword_length > 0 ? keyword_length : content_arr.length,
            dictionary,
            category,
            currentTestPost?.content,
            null,
            isCore,
          );

          if (result?.error !== undefined && result?.error !== null) {
            if (!checkAnswerState) {
              swal({
                title: "Sending grammar check to server went wrong .",
                text: "You can retry after reloading .Press okay to reload ,your current progress is saved .Cancel will continue the test but your answer will not be correct.",
                icon: "error",
                buttons: true,
                dangerMode: true,
                closeOnClickOutside: false,
              }).then((ok) => {
                if (ok) {
                  window.location.reload();
                } else {
                  if (!checkAnswerState) {
                    storeData.score[index] = 0;
                    storeData.answer[index][0] = effectiveChar;
                  }
                  setCalculationLoading(false);
                  pageCondition();
                  return;
                }
              });
              return;
            } else {
              setOverallPoint(0);
              setContentAns(0);
              setCalculationLoading(false);
              return;
            }
          }
          if (category === "swt") {
            score =
              result?.cal_content +
              result?.form +
              result?.cal_grammar_mark +
              result?.voca_score;
            points = {
              content: result?.cal_content,
              form: result?.form,
              grammar: result?.cal_grammar_mark,
              vocabulary: result?.voca_score,
            };
          } else if (category === "sst") {
            score =
              result?.cal_content +
              result?.form +
              result?.cal_grammar_mark +
              result?.voca_score +
              result?.spellng_language_tool;
            points = {
              content: result?.cal_content,
              form: result?.form,
              grammar: result?.cal_grammar_mark,
              vocabulary: result?.voca_score,
              spelling: result?.spellng_language_tool,
            };
          } else if (isEmail) {
            // wemail (PTE Core) scoring
            score =
              result?.cal_content +
              result?.form +
              result?.cal_grammar_mark +
              result?.form +
              result?.spellng_language_tool +
              result?.emailConventionPoints +
              result?.organizationalPoints;
            points = {
              content: result?.cal_content,
              form: result?.form,
              grammar: result?.cal_grammar_mark,
              spelling: result?.spellng_language_tool,
              vocabulary: result?.form,
              dsc: result?.emailConventionPoints,
              linguistic: result?.organizationalPoints,
            };
          } else if (isEssay) {
            // we (PTE Academy) scoring
            score =
              result?.cal_content +
              result?.form +
              result?.cal_grammar_mark +
              result?.spellng_language_tool +
              result?.form +
              result?.dsc +
              result?.linguistic;
            points = {
              content: result?.cal_content,
              form: result?.form,
              grammar: result?.cal_grammar_mark,
              spelling: result?.spellng_language_tool,
              vocabulary: result?.form,
              dsc: result?.dsc,
              linguistic: result?.linguistic,
            };
          }

          setGrammarMark(result?.cal_grammar_mark);
          setContentAns(result?.cal_content);
          setWordForm(result?.form);
          setDsc(isEmail ? result?.emailConventionPoints : result?.dsc);
          setLinguistic(
            isEmail ? result?.organizationalPoints : result?.linguistic,
          );
          setVocabulary(category === "swt" ? result?.voca_score : result?.form);
          setSpelling(
            isEmail ? result?.spellng_language_tool : result?.spelling,
          );
          if (score === undefined) {
            setOverallPoint(0);
          } else {
            setOverallPoint(score);
          }
        } else {
          const specialCharactersRegex = /[!@#$%^&*(),.?":{}|<>]/g;
          let char_arr = effectiveChar
            .replace(specialCharactersRegex, "")
            .split(" ");

          content_arr = currentTestPost.content
            .replace(specialCharactersRegex, "")
            .split(" ");
          let overall_point = 0;
          content_arr.forEach((check_char) => {
            if (char_arr.includes(check_char)) {
              // showWord.push({ name: check_char, color: "#16A085" }); // This would mutate the state, which is not allowed
              // setShowWord(showWord);
              // setCount((prevtotalCount) => prevtotalCount + 1);
              overall_point += 1;
            } else {
              // showWord.push({ name: check_char, color: "#F21F21" }); // This would mutate the state, which is not allowed
              // setShowWord(showWord);
            }
          });
          score = ((overall_point / content_arr.length) * 12).toFixed(0);

          points = {
            content: score,
          };
          setOverallPoint(score);
          setContentAns(score);
          setCalculationLoading(false);
        }
        setCalculationLoading(false);
        if (!checkAnswerState) {
          storeData.score[index] = score;
          storeData.answer[index][0] = effectiveChar;
          storeData.points[index] = points;
        }
        if (!checkAnswerState) {
          pageCondition();
        }
      } else {
        setOverallPoint(0);

        setContentAns(0);
        if (!checkAnswerState) {
          storeData.score[index] = 0;
          storeData.answer[index][0] = "";

          pageCondition();
        }
        setCalculationLoading(false);
      }
    },
    [
      category,
      char,
      pageCondition,
      dictionary,
      index,
      storeData,
      setPause,

      testPost,
      checkAnswerState,
    ],
  );

  // Sync ref AFTER save_score is defined
  save_score_ref.current = save_score;

  useEffect(() => {
    // console.log(Object.keys(answer).length, "Answer in ReusableTest");
    if (!answer || Object.keys(answer).length === 0) return;
    if (
      checkAnswerState &&
      answer !== undefined &&
      answer?.answers !== undefined
    ) {
      let answerArray = JSON.parse(answer.answers);
      setText(answerArray[index] ? answerArray[index][0] : "");
    }
  }, [checkAnswerState, answer, index]); //for check answer

  useEffect(() => {
    if (
      checkAnswerState &&
      answer !== undefined &&
      answer?.answers !== undefined
    ) {
      // let textBox = document.getElementById("textBox");
      // console.log(answer, "Answer in ReusableTest");
      if (Object.keys(answer).length === 0) {
        return;
      }
      // textBox.value = answer.answers[index][0];
      let answerArray = JSON.parse(answer.answers);
      // const givenDate = new Date(answer.created_at); // Example: August 7, 2025
      // const cutoffDate = new Date("2025-08-12T00:00:00.000Z"); // August 12, 2025 (UTC)

      setContentMaxScore(
        isEmail
          ? 3 // Write Email: Content max = 3 (new rubric)
          : isEssay
            ? 6
            : category === "swt"
              ? isCore
                ? 2
                : 4
              : category === "sst"
                ? isCore
                  ? 2
                  : 4
                : 4,
      );

      // textBox.value = answerArray[index][0];
      let char = answerArray[index] ? answerArray[index][0] : "";
      console.log(
        "[checkAnswer useEffect] index:",
        index,
        "| local char:",
        JSON.stringify(char),
        "| char length:",
        char.length,
      );
      const char_arr =
        char === ""
          ? ""
          : char
              .trim()
              .replace(/[.,?']/g, "")
              .split(/\s+/)
              .filter((word) => word !== "");
      setChar(char);
      setWordCount(char_arr === "" ? 0 : char_arr.length);
      // Reset scores before recalculating for the new question
      setGrammarMark(0);
      setContentAns(0);
      setWordForm(0);
      setDsc(0);
      setLinguistic(0);
      setVocabulary(0);
      setSpelling(0);
      setOverallPoint(0);
      if (dictionary !== null) {
        console.log(
          "[checkAnswer useEffect] calling save_score with:",
          JSON.stringify(char),
        );
        // Use ref so this effect doesn't re-run every time save_score's closure updates
        save_score_ref.current(char);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkAnswerState, answer, index, dictionary]);

  //for test answer
  useEffect(() => {
    const executeEffect = async () => {
      if (timerCounterCount === 0 || (category === "wfd" && next)) {
        if (!checkAnswerState) {
          setTimerCounterCount(timerCounterDuration);

          await save_score(); // Await the async function
        }
      }
    };
    executeEffect();
  }, [
    timerCounterCount,
    checkAnswerState,

    save_score,
    char,
    setCurrentQuestionStart,
    next,
    mockType,
    storeData,
    dictionary,
    index,
    props,
    category,
    setCategoryState,
    reset,
    testPost,
    timerCounterDuration,
    setWritingState,
    setListeningState,
    setCurrentPage,
  ]);

  console.log(
    error,
    "Error in ReusableTest >>>",
    contentAns,
    overallPoint,
    grammarMark,
    wordForm,
    dsc,
    linguistic,
    vocabulary,
    spelling,
  );
  return (
    <ErrrorBoundaryClass
      fallback={
        <MtErrorFallbackFunction
          error={error}
          setError={setError}
        ></MtErrorFallbackFunction>
      }
    >
      <>
        <Box
          sx={{
            mt: "2rem",
            px: checkAnswerState
              ? 2
              : {
                  xs: 2,
                  sm: 5,
                  md: 10,
                  lg: "10rem",
                  xl: "20rem",
                },
          }}
        >
          <Box sx={{ backgroundColor: "rgb(231,239,254)", height: "100%" }}>
            <Box
              sx={{
                backgroundColor: "white",
                borderRadius: "2rem",
                p: 2,
                boxShadow: 5,
              }}
            >
              <Box sx={{ width: "100%" }}>
                <Typography variant="body5">
                  {category === "we"
                    ? "You will have 20 minutes to plan, write and revise an essay about the topic below. Your response will be judged on how well you develop a position, organize your ideas, present supporting details, and control the elements of standard written English. You should write 200-300 words."
                    : category === "wemail"
                      ? "You will have 9 minutes to plan, write and revise an email about the topic below. Your response will be judged on how well you address the purpose, organize your ideas, present supporting details, and control the elements of standard written English. You should write between 80 and 120 words."
                      : category === "swt"
                        ? isCore
                          ? "Read the passage below and summarize it using between 25 to 50 words.Type your response in the box at the bottom of the screen. You have 10 minutes to finish this task. Your response will be judged on the quality of your writing and on how well your response present the key points in the passage."
                          : "Read the passage below and summarize it using one sentence of no more than 75 words. Type your response in the box at the bottom of the screen. You have 10 minutes to finish this task. Your response will be judged on the quality of your writing and on how well your response presents the key points in the passage."
                        : category === "sst"
                          ? `You will hear a short audio. Write a summary for a fellow student who was not present at the Interview/Lecture. You should write ${isCore ? "20-30" : "50-70"} words. You have ${isCore ? "8" : "10"} minutes to finish this task. Your response will be judged on the quality of your writing and on how well your response presents the key points presented in the interview.`
                          : " You will hear a sentence.Type the sentence in the box below exactly as you heard it.Write as much of the sentence as you an.You will hear the sentence only once."}
                </Typography>
              </Box>
              {/* Audio */}
              {(category === "wfd" || category === "sst") && (
                <Box>
                  {audio !== "" && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        mt: 2,
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          width: {
                            md: "30%",
                            sm: "50%",
                            xs: "100%",
                          },
                          boxShadow: 5,
                        }}
                        disabled={!checkAnswerState}
                      >
                        <audio
                          controls
                          disabled
                          id="audio"
                          src={audio}
                          onEnded={() =>
                            category === "wfd"
                              ? setBeginningStatus(false)
                              : audioEndHandler()
                          }
                          preload="metadata"
                          onLoadedMetadata={onLoadedMetaData}
                          // autoPlay
                        ></audio>
                      </Button>
                    </Box>
                  )}
                </Box>
              )}

              {category !== "wfd" && (
                <Box
                  sx={{
                    width: "100%",
                    height: "5vh",
                    my: "0.3rem",
                    mx: "auto",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Box>
                    <Typography>
                      Duration{" "}
                      {Math.floor(timerCounterCount / 60) < 10
                        ? "0" + Math.floor(timerCounterCount / 60)
                        : Math.floor(timerCounterCount / 60)}{" "}
                      :
                      {timerCounterCount % 60 < 10
                        ? "0" + Math.floor(timerCounterCount % 60)
                        : Math.floor(timerCounterCount % 60)}
                    </Typography>
                  </Box>
                </Box>
              )}

              <Box sx={{ margin: "0 auto", width: "100%", mb: 4 }}>
                {isWriting && (
                  <Box
                    sx={{
                      p: 1,
                      backgroundColor: "whitesmoke",
                      borderRadius: "1rem",
                      boxShadow: 5,
                      height: "auto",
                      wordWrap: "break-word",
                    }}
                  >
                    <Typography
                      variant="body5"
                      sx={{
                        wordWrap: "break-word",
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {currentTestPost?.content || "Loading question..."}
                    </Typography>
                  </Box>
                )}

                <Box sx={{ margin: "0 auto", width: "100%", py: 2 }}>
                  <Box
                    sx={{
                      width: "100%",
                      margin: "0 auto",

                      borderRadius: "0.5rem",
                      padding: 1,
                      boxShadow: 1,
                    }}
                  >
                    {/* <Typography sx={{ my: 2, fontSize: "1.2rem" }}>
                            {content}
                          </Typography> */}
                    <FormGroup>
                      <TextareaAutosize
                        id="textBox"
                        aria-label="minimum height"
                        spellCheck={false}
                        minRows={10}
                        value={text}
                        placeholder={
                          category === "wemail"
                            ? "Write an Email..."
                            : category === "we"
                              ? "Write an Essay..."
                              : category === "swt" || category === "sst"
                                ? "Write a Summary..."
                                : "Write here..."
                        }
                        style={{
                          width: "100%",
                          fontSize: "1.2rem",
                          padding: "1rem",
                        }}
                        disabled={checkAnswerState ? true : false}
                        autoFocus
                        onChange={checkWord}
                      />
                    </FormGroup>
                    <Box>
                      <Typography variant="h6">
                        Word Count : {wordCount}
                      </Typography>
                    </Box>
                  </Box>

                  {/* {checkStatus && (
                    <Typography
                      sx={{
                        textAlign: "center",
                        color: "red",
                        marginTop: 2,
                      }}
                    >
                      *Word count contains less than 40 words or more than 100
                      words. No further scoring.
                    </Typography>
                  )} */}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {calculationLoading && checkAnswerState && (
          <Box sx={{ my: 2, p: 2, display: "flex" }}>
            <Typography variant="h4">Getting calculation result</Typography>
            <CircularProgress
              sx={{ width: "20%", color: "blue" }}
            ></CircularProgress>
          </Box>
        )}

        {!calculationLoading && props.checkAnswerState && (
          <Box sx={{ px: 2 }}>
            <Typography variant="h5" my={2}>
              Score
            </Typography>
            <Box sx={{ width: "100%", textAlign: "center" }}>
              <Box
                sx={{
                  display: {
                    md: "flex",
                    sm: "column",
                    xs: "column",
                  },
                  width: "100%",
                  margin: "0 auto",
                  justifyContent: {
                    md: "space-evenly",
                    sm: "center",
                    xs: "center",
                  },
                  alignItems: "center",
                  pl: {
                    md: 4,
                    sm: 0,
                    xs: 0,
                  },
                  py: 3,
                  backgroundColor: "#fff",
                  borderRadius: "1rem 1rem  0rem 0rem",
                }}
              >
                <Box sx={{ width: "15%", margin: "0 auto" }}>
                  <h3
                    style={{
                      whiteSpace: "nowrap",
                      textAlign: "center",
                      marginBottom: 5,
                    }}
                  >
                    Content
                  </h3>
                  <CircularProgressbar
                    value={contentAns}
                    maxValue={
                      category === "wfd"
                        ? 12
                        : isEssay || isEmail || category === "swt"
                          ? contentMaxScore
                          : // : category === "swt"
                            // ? contentMaxScore
                            category === "sst"
                            ? contentMaxScore
                            : 2
                    }
                    text={`${contentAns}/${
                      category === "wfd"
                        ? 12
                        : isEssay || isEmail
                          ? contentMaxScore
                          : category === "swt"
                            ? contentMaxScore
                            : category === "sst"
                              ? contentMaxScore
                              : 2
                    }`}
                  />
                </Box>

                <br />
                {category !== "wfd" && (
                  <>
                    <Box sx={{ width: "15%", margin: "0 auto" }}>
                      <h3
                        style={{
                          whiteSpace: "nowrap",
                          textAlign: "center",
                          marginBottom: 5,
                        }}
                      >
                        Form
                      </h3>
                      <CircularProgressbar
                        value={wordForm}
                        maxValue={category === "swt" ? (isCore ? 2 : 1) : 2}
                        text={`${wordForm}/${category === "swt" ? (isCore ? 2 : 1) : 2}`}
                      />
                    </Box>
                    <Box sx={{ width: "15%", margin: "0 auto" }}>
                      <h3
                        style={{
                          whiteSpace: "nowrap",
                          textAlign: "center",
                          marginBottom: 5,
                        }}
                      >
                        Grammar
                      </h3>
                      <CircularProgressbar
                        value={grammarMark}
                        maxValue={2}
                        text={`${grammarMark}/2`}
                      />
                    </Box>
                    {/* vocabulary is now used as spelling */}
                    {category !== "swt" && (
                      <Box sx={{ width: "15%", margin: "0 auto" }}>
                        <h3
                          style={{
                            whiteSpace: "nowrap",
                            textAlign: "center",
                            marginBottom: 5,
                          }}
                        >
                          Spelling
                        </h3>
                        <CircularProgressbar
                          value={spelling}
                          maxValue={2}
                          text={`${spelling}/2`}
                        />
                      </Box>
                    )}

                    {/* vocabulary is same as form */}
                    <Box sx={{ width: "15%", margin: "0 auto" }}>
                      <h3
                        style={{
                          whiteSpace: "nowrap",
                          textAlign: "center",
                          marginBottom: 5,
                        }}
                      >
                        Vocabulary
                      </h3>
                      <CircularProgressbar
                        value={vocabulary}
                        maxValue={2}
                        text={`${vocabulary}/2`}
                      />
                    </Box>
                  </>
                )}
              </Box>
              {(isEssay || isEmail) && (
                <Box
                  sx={{
                    display: {
                      md: "flex",
                      sm: "column",
                      xs: "column",
                    },
                    width: "100%",
                    margin: "0 auto",
                    justifyContent: {
                      md: "space-evenly",
                      sm: "center",
                      xs: "center",
                    },
                    alignItems: "center",
                    pl: {
                      md: 4,
                      sm: 0,
                      xs: 0,
                    },
                    py: 3,
                    backgroundColor: "#fff",
                    borderRadius: "1rem 1rem  0rem 0rem",
                  }}
                >
                  {/* General Linguistics / Email Convention */}
                  <Box
                    sx={{ width: "15%", margin: "0 auto", textAlign: "center" }}
                  >
                    <h3
                      style={{
                        whiteSpace: "nowrap",
                        textAlign: "center",
                        marginBottom: 5,
                      }}
                    >
                      {isEmail ? "Email" : "General"} <br />{" "}
                      {isEmail ? "Convention" : "Linguistic Range"}
                    </h3>
                    <CircularProgressbar
                      value={linguistic}
                      maxValue={contentMaxScore == 3 ? 2 : 6}
                      text={`${linguistic}/${contentMaxScore == 3 ? 2 : 6}`}
                    />
                  </Box>
                  {/* DSC / Organization */}
                  <Box
                    sx={{ width: "15%", margin: "0 auto", textAlign: "center" }}
                  >
                    <h3
                      style={{
                        whiteSpace: "nowrap",
                        textAlign: "center",
                        marginBottom: 5,
                      }}
                    >
                      {isEmail ? "Organization" : "Development,"}
                      {isEmail ? null : (
                        <>
                          <br /> structure and coherence
                        </>
                      )}
                    </h3>
                    <CircularProgressbar
                      value={dsc}
                      maxValue={contentMaxScore == 3 ? 2 : 6}
                      text={`${dsc}/${contentMaxScore == 3 ? 2 : 6}`}
                    />
                  </Box>
                </Box>
              )}
              <Box
                sx={{
                  width: "100%",
                  textAlign: "center",
                  backgroundColor: "#fff",
                  padding: "  10px",
                  borderRadius: "0rem 0rem 1rem 1rem  ",
                }}
              >
                <Card>
                  <CardHeader
                    // titleTypographyProps={{variant:'h1' }}
                    title=" Writing Comments"
                    sx={{
                      bgcolor: "grey",
                      textAlign: "left",
                      fontSize: 10,
                    }}
                  />

                  <CardContent>
                    <Box sx={{ width: "100%", textAlign: "center" }}>
                      <Box
                        sx={{
                          display: {
                            md: "flex",
                            sm: "column",
                            xs: "column",
                          },
                          width: "100%",
                          margin: "0 auto",
                          justifyContent: {
                            md: "space-evenly",
                            sm: "center",
                            xs: "center",
                          },
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ width: "50%", margin: "0 auto" }}>
                          <Typography>Error Count : {errorCount}</Typography>
                          <Typography>Word Count : {wordCount}</Typography>
                          <Typography>
                            Error Density :{" "}
                            {wordCount > 0
                              ? ((errorCount / wordCount) * 100).toFixed(2)
                              : "0.00"}{" "}
                            %
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            width: "100%",
                            margin: "0 auto",
                            [theme.breakpoints.up("sm")]: {
                              width: "30%",
                              my: 2,
                            },
                            [theme.breakpoints.up("md")]: {
                              width: "30.33%",
                            },
                            [theme.breakpoints.up("lg")]: {
                              width: "15%",
                            },
                          }}
                        >
                          <h3
                            style={{
                              whiteSpace: "nowrap",
                              textAlign: "center",
                              marginBottom: 5,
                            }}
                          >
                            Overall Point
                          </h3>
                          <CircularProgressbar
                            value={`${
                              category === "wfd" ? contentAns : overallPoint
                            }`}
                            maxValue={`${
                              category === "wfd"
                                ? 12
                                : isEmail
                                  ? contentMaxScore == 2
                                    ? 14 // Old Write Email: 14 points
                                    : 15 // New Write Email: 15 points
                                  : isEssay
                                    ? contentMaxScore == 3
                                      ? 15
                                      : 26
                                    : category === "swt"
                                      ? 8
                                      : category === "sst"
                                        ? contentMaxScore == 2
                                          ? 10
                                          : 12
                                        : ""
                            }`}
                            text={`${
                              category === "wfd" ? contentAns : overallPoint
                            }/${
                              category === "wfd"
                                ? 12
                                : isEmail
                                  ? 15
                                  : isEssay
                                    ? 26
                                    : category === "swt"
                                      ? isCore
                                        ? 8
                                        : 9
                                      : category === "sst"
                                        ? contentMaxScore == 2
                                          ? 10
                                          : 12
                                        : ""
                            }`}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
            </Box>
          </Box>
        )}

        <Box
          sx={{
            width: "100%",
            display: "flex",
            mt: 5,
            pb: 2,
            justifyContent: "flex-end",
          }}
        >
          <Button
            variant="contained"
            sx={{ mr: "1rem", mb: "1rem" }}
            onClick={clickHandler}
            disabled={
              dbSaveLoading || calculationLoading
                ? true
                : checkByAdmin === true
                  ? false
                  : (category === "wfd" || category === "sst") &&
                      !checkAnswerState
                    ? beginningStatus
                    : false
            }
          >
            {dbSaveLoading ? (
              <CircularProgress size="1rem"></CircularProgress>
            ) : (
              ""
            )}
            {(category === "we" || (category === "swt" && isCore)) &&
            index === testPost.length - 1
              ? "Finish Section"
              : "Next"}
          </Button>
        </Box>
      </>
    </ErrrorBoundaryClass>
  );
}

export default ReusableTest;
